exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form[data-v-05cc65d0]{width:480px}.el-select[data-v-05cc65d0],.el-input[data-v-05cc65d0]{width:100%}", ""]);

// exports
